/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/remote.png'
import avevaLogo from '@/assets/aveva/Aveva_logo.svg'
import ignitionLogo from '@/assets/ignition/ignition-logo.svg'

function ScadaTopNode({ data, isConnectable }) {
  const scadaLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return avevaLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return ignitionLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return ignitionLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return ignitionLogo
    }
  }
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={scadaLogo()} alt="Scada Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>SCADA</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Top} />
      <Handle type="source" position={Position.Top} />
    </div>
  )
}

export default ScadaTopNode
